import { computed } from 'vue'

import { useAuth } from '@common/auth-layer/composables/useAuth'
import { resolveCpBreadcrumbRegistryKey } from '@common/navigation-layer/config/cp-breadcrumb-registry'
import type { SearchContext } from '@common/shared-ui-layer/types/search-context'

import { useEventsDirectorySearch } from './useEventsDirectorySearch'

import type { RouteLocationNormalizedLoaded } from 'vue-router'

export const EVENTS_DIRECTORY_ROUTE_KEY = 'clientportal-events-live'

export const isEventsDirectoryRoute = (route: RouteLocationNormalizedLoaded): boolean =>
  resolveCpBreadcrumbRegistryKey(route) === EVENTS_DIRECTORY_ROUTE_KEY

/**
 * Mobile top-bar search for the live events directory. Filters the loaded directory in place through the
 * shared events search store instead of navigating to a search page.
 */
export function useEventsSearchContext(route: RouteLocationNormalizedLoaded): SearchContext {
  const authStore = useAuth().store
  const { searchQuery, setSearchQuery, reset } = useEventsDirectorySearch()

  return {
    shouldShowSearch: computed(() => authStore.isLoggedIn && isEventsDirectoryRoute(route)),
    initialQuery: computed(() => searchQuery.value),
    onSubmit: setSearchQuery,
    onInputChange: setSearchQuery,
    onSearchClose: reset,
  }
}
